// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__9hkzD","loader":"Loader_loader__s4N3W","load8":"Loader_load8__OHWmM"};